/**
 * Admin Preferences Configuration
 * Defines global admin settings, feature flags, and brand information
 *
 * NOTE: Brand-specific values (title, baseUrl, brand.name, etc.) are
 * intentionally left as placeholders here. They are overridden at runtime
 * by mergeAdminPreferences() in brands.config.ts using the selected brand's
 * configuration from the BRAND environment variable.
 *
 * DO NOT hardcode brand-specific values here.
 */

export const adminPreferences = {
	title: 'App', // Populated from brand config
	baseUrl: 'http://localhost:3000', // Populated from brand config (placeholder for client-side)
	auth: true,
	brand: {
		name: 'App', // Populated from brand config
		shortName: 'App', // Populated from brand config
		baseUrl: 'http://localhost:3000', // Populated from brand config (placeholder for client-side)
		description: '', // Populated from brand config
	},
	features: {
		auth: {
			signup: {
				enabled: true,
			},
		},
		multiLanguage: false,
		configStudio: true,
		emailStudio: true,
		course: {
			studyPlan: true,
			addModulesAndTopics: true,
			content: true,
			notes: true,
			diagram: true,
			duplicate: true,
			export: true,
			templates: true,
			instances: true,
			marketing: true,
			publicPreview: true,
			enableOriginalContentFacet: true,
			enableNotesFacet: true,
			enableLlmContent: true,
		},
		topic: {
			content: true,
			resources: true,
			notes: true,
			diagram: true,
			// Off by default: learners get the curated resources, not a tool to
			// gather more. The admin preferences can switch it back on.
			collectResources: false,
			collectTopicResources: true,
			manage: true,
			enableOriginalContentFacet: true,
			enableNotesFacet: true,
			enableLlmContent: true,
		},
		resource: {
			enableOriginalContentFacet: false,
			enableNotesFacet: true,
			enableLlmContent: true,
		},
		enrollments: {
			cloneCourseCoverArtifacts: {
				enabled: true,
			},
			cloneCourseDiagramArtifacts: {
				enabled: true,
			},
			cloneTopicArtifacts: {
				enabled: true,
			},
			cloneResourceArtifacts: {
				enabled: true,
			},
		},
		artifacts: {
			templateFallback: {
				enabled: false,
			},
			copyOnWrite: {
				enabled: false,
			},
		},
		courseCreation: {
			enabled: true,
		},
		collections: {
			enabled: false,
		},
	},
	settings: {
		enabled: true,
		routes: {
			account: false,
			appearance: true,
			display: false,
			notifications: false,
			profile: true,
		},
	},
	'app-sidebar': {},
} as const

export type AdminPreferences = typeof adminPreferences
